export default __webpack_public_path__ + "static/media/Record_StartRecord.50dc34f3.svg";